import { render } from "./concept-details.vue?vue&type=template&id=70bae945"
import script from "./concept-details.vue?vue&type=script&lang=js"
export * from "./concept-details.vue?vue&type=script&lang=js"

import "./concept-details.vue?vue&type=style&index=0&id=70bae945&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__